export default {
  path: "/feedback",
  redirect: "/feedback/index",
  meta: {
    icon: "mdi:comment-account",
    showLink: true,
    title: "用户反馈",
    rank: 30
  },
  children: [
    {
      path: "/feedback/index",
      name: "feedback",
      component: () => import("@/views/feedback/index.vue"),
      meta: {
        title: "用户反馈"
      }
    }
  ]
} satisfies RouteConfigsTable;
